/** @format */

export const SERVICE_DAP_BCN_ZERO = 'SERVICE_DAP_BCN_ZERO';
export const SERVICE_DAP_BCN_APPROACHING_ZERO = 'SERVICE_DAP_BCN_APPROACHING_ZERO';

export const PACKAGE_ACTIVATE = 'PACKAGE_ACTIVATE';
export const PACKAGE_USAGE_80_PERCENT = 'PACKAGE_USAGE_80_PERCENT';
export const PACKAGE_USAGE_ALL = 'PACKAGE_USAGE_ALL';
export const PACKAGE_NEAR_EXPIRE = 'PACKAGE_NEAR_EXPIRE';
export const PACKAGE_EXPIRE = 'PACKAGE_EXPIRE';

export const PARAM_7XXX_BARRING_ON = 'PARAM_7XXX_BARRING_ON';
export const PARAM_7XXX_BARRING_OFF = 'PARAM_7XXX_BARRING_OFF';
export const PARAM_080X_BARRING_ON = 'PARAM_080X_BARRING_ON';
export const PARAM_080X_BARRING_OFF = 'PARAM_080X_BARRING_OFF';
export const PARAM_070X_BARRING_ON = 'PARAM_070X_BARRING_ON';
export const PARAM_070X_BARRING_OFF = 'PARAM_070X_BARRING_OFF';
